/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/upload
 */
import { default as DefaultIcon } from '~icons/lucide/upload';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const UploadIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
